export default {
  data() {
    return {
      searchSchema: [
        {
          label: '客户编号',
          type: 'input',
          itemName: 'customerCode',
        },
        {
          label: '客户名称',
          type: 'input',
          itemName: 'customerName',
        },
        {
          label: '状态',
          type: 'select',
          itemName: 'status',
          selectList: [
            {
              value: 0,
              text: '生效',
            },
            {
              value: 1,
              text: '失效',
            },
          ],
        },
      ],
      searchForm: {
        customerCode: '',
        customerName: '',
        status: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'customerCode',
        },
        {
          title: '客户名称',
          width: 200,
          dataIndex: 'customerName',
        },
        {
          title: '状态',
          width: 140,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
